import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import { OrderFormValues } from "src/models/Order.model";

type Props = {
  formikProps: FormikProps<OrderFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
};

const OrderForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "ADD" ? "Add Order" : "Update Order"}
        </div>
        <button type="button" className="hover:bg-gray-200 px-2 py-1 rounded" onClick={onClose}>
          Cancel
        </button>
      </div>

      {/* Form Fields */}
      <div className="flex flex-col gap-4">
        <ATMTextField
          name="transactionId"
          required
          value={values.transactionId}
          onChange={(e) => setFieldValue("transactionId", e.target.value)}
          label="Payment Id"
          onBlur={handleBlur}
        />

        <ATMTextField
          name="paymentGateway"
          required
          value={values.paymentGateway}
          onChange={(e) => setFieldValue("paymentGateway", e.target.value)}
          label="Payment Gateway"
          onBlur={handleBlur}
        />

        <ATMTextField
          name="couponCode"
          required
          value={values.couponCode}
          onChange={(e) => setFieldValue("couponCode", e.target.value)}
          label="Coupon Code"
          onBlur={handleBlur}
        />

        <ATMTextField
          name="referralCode"
          required
          value={values.referralCode}
          onChange={(e) => setFieldValue("referralCode", e.target.value)}
          label="Referral Code"
          onBlur={handleBlur}
        />

        <ATMTextArea
          name="deliveryDetails.address"
          placeholder="Enter Address"
          label="Address"
          onChange={(e) => setFieldValue("deliveryDetails.address", e)}
          value={values.deliveryDetails.address}
        />

        <ATMTextField
          name="deliveryDetails.city"
          value={values.deliveryDetails.city}
          onChange={(e) => setFieldValue("deliveryDetails.city", e.target.value)}
          label="City"
          placeholder="Enter City"
          onBlur={handleBlur}
        />

        <ATMTextField
          name="deliveryDetails.state"
          value={values.deliveryDetails.state}
          onChange={(e) => setFieldValue("deliveryDetails.state", e.target.value)}
          label="State"
          placeholder="Enter State"
          onBlur={handleBlur}
        />

        <ATMTextField
          name="deliveryDetails.pincode"
          value={values.deliveryDetails.pincode}
          onChange={(e) => setFieldValue("deliveryDetails.pincode", e.target.value)}
          label="Pincode"
          placeholder="Enter Pincode"
          onBlur={handleBlur}
        />

        <ATMTextField
          name="deliveryDetails.firstName"
          value={values.deliveryDetails.firstName}
          onChange={(e) => setFieldValue("deliveryDetails.firstName", e.target.value)}
          label="First Name"
          placeholder="Enter First Name"
          onBlur={handleBlur}
        />

        <ATMTextField
          name="deliveryDetails.lastName"
          value={values.deliveryDetails.lastName}
          onChange={(e) => setFieldValue("deliveryDetails.lastName", e.target.value)}
          label="Last Name"
          placeholder="Enter Last Name"
          onBlur={handleBlur}
        />

        <ATMTextField
          name="deliveryDetails.email"
          value={values.deliveryDetails.email}
          onChange={(e) => setFieldValue("deliveryDetails.email", e.target.value)}
          label="Email"
          placeholder="Enter Email"
          onBlur={handleBlur}
        />

        <ATMTextField
          name="deliveryDetails.altMobile"
          value={values.deliveryDetails.altMobile}
          onChange={(e) => setFieldValue("deliveryDetails.altMobile", e.target.value)}
          label="Alternate Mobile"
          placeholder="Enter Alternate Mobile"
          onBlur={handleBlur}
        />

        {/* Buttons */}
        <div className="flex justify-end mt-2 px-3 gap-2">
          <ATMLoadingButton className="w-24 bg-red-500 text-white font-medium" type="button" onClick={onClose}>
            Cancel
          </ATMLoadingButton>
          <ATMLoadingButton className="w-24" isLoading={isSubmitting} type="submit">
            Save
          </ATMLoadingButton>
        </div>
      </div>
    </div>
  );
};

export default OrderForm;
